import React, { useState } from "react";
import { Modal } from "react-responsive-modal";
import UserDefaultAvatar from "assets/img/user.svg";
import { useUserContext } from "store/contexts/userContext";
import Scrollbar from "react-scrollbars-custom";
import Button from "components/CustomButton";

var styles = {
  titleDailog: {
    padding: "24px 24px 10px",
    fontSize: "1.25rem",
    fontWeight: "900",
    marginBottom: "0",
    display: "flex",
    justifyContent: "center",
  },
  headingDailog: {
    fontSize: "1rem",
    padding: "0px 24px",
    marginBottom: "12px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  avatar: {
    minHeight: "30px",
    height: "30px",
    minWidth: "30px",
    width: "30px",
    borderRadius: "50%",
  },
  actionButton: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    textAlign: "center",
    padding: "10px 8px",
  },
};


export default ({
  description,
  tagged_users,
  isForwarded = false,
  countUserTag,
  post = true,
  team,
  heading = "Recognized Members",
}) => {
  const classes = styles;
  const { user } = useUserContext();
  const [showRecognizeModal, setRecognizedModal] = useState(false);
  const [allTagUsers] = useState(
    !post && countUserTag === 0 ? team.users : tagged_users
  );
  const descriptionStyle = {
    cursor: !post || countUserTag ? "pointer" : "unset",
  };

  const handleModal = () => {
    setRecognizedModal(!showRecognizeModal);
  };

  const callModal = () => {
    if (!post || countUserTag) {
      handleModal();
    }
    return;
  };

  return (
    <>
      <span onClick={callModal} style={descriptionStyle}>
        {description}
      </span>
      <Modal
        open={showRecognizeModal}
        onClose={() => setRecognizedModal(false)}
        showCloseIcon={false}
        center={true}
        classNames={{
          modalContainer: "modalContainer",
          modal: "rootModalContainer",
        }}
      >
        <h2 style={classes.titleDailog}>{heading}</h2>
        <div style={classes.headingDailog}>
          {!isForwarded && (
            <Scrollbar
              translateContentSizeYToHolder={true}
              style={{
                maxHeight: "calc(100vh - 300px)",
              }}
            >
              {allTagUsers?.map((member) => (
                <div key={member?.id} className="recognizedMemberContent">
                  <div style={classes.avatar}>
                    <img
                      alt={`${member.avatar}`}
                      style={classes.avatar}
                      src={member.avatar ?? UserDefaultAvatar}
                    />
                  </div>
                  {user?.id === member?.id && (
                    <span>{member?.full_name} (You)</span>
                  )}
                  {user?.id !== member?.id && <span>{member?.full_name}</span>}
                </div>
              ))}
            </Scrollbar>
          )}
          {isForwarded && <span>Anonymous Users</span>}
        </div>
        <div style={classes.actionButton}>
          <Button
            buttonClass="small-btn me-2"
            onClick={() => {
              setRecognizedModal(false);
            }}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  );
};
